/**
 * Custom header - theme toggle and drawer
 */
(function () {
  const THEME_KEY = 'custom-header-theme';
  const THEME_DARK = 'theme-dark';
  const DRAWER_OPEN_CLASS = 'custom-header-drawer-open';

  function getStoredTheme() {
    try {
      return localStorage.getItem(THEME_KEY);
    } catch (e) {
      return null;
    }
  }

  function setStoredTheme(value) {
    try {
      if (value) {
        localStorage.setItem(THEME_KEY, value);
      } else {
        localStorage.removeItem(THEME_KEY);
      }
    } catch (e) {}
  }

  function applyTheme(value) {
    const root = document.documentElement;
    if (value === 'dark') {
      root.classList.add(THEME_DARK);
    } else {
      root.classList.remove(THEME_DARK);
    }
  }

  function initThemeToggle() {
    const toggle = document.querySelector('[data-theme-toggle]');
    if (!toggle) return;

    const defaultTheme = document.querySelector('[data-theme-default]');
    const initial = defaultTheme ? defaultTheme.getAttribute('data-theme-default') : null;
    const systemDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;

    let current = getStoredTheme();
    if (!current) {
      if (initial === 'system') {
        current = systemDark ? 'dark' : 'light';
      } else {
        current = initial || 'light';
      }
    }

    applyTheme(current);

    toggle.addEventListener('click', function () {
      current = current === 'dark' ? 'light' : 'dark';
      setStoredTheme(current);
      applyTheme(current);
    });

    if (window.matchMedia) {
      window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', function (e) {
        if (getStoredTheme() === 'system' || !getStoredTheme()) {
          applyTheme(e.matches ? 'dark' : 'light');
        }
      });
    }
  }

  function initDrawer() {
    const drawer = document.getElementById('custom-header-drawer');
    const openButtons = document.querySelectorAll('[data-drawer-open]');
    const closeButtons = document.querySelectorAll('[data-drawer-close]');

    if (!drawer) return;

    let lastFocusBeforeOpen = null;

    function getFocusableElements() {
      const selector =
        'a[href]:not([disabled]), button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';
      return Array.prototype.filter.call(drawer.querySelectorAll(selector), function (el) {
        if (el.closest('[hidden]') || el.getAttribute('aria-hidden') === 'true') return false;
        const style = window.getComputedStyle(el);
        return style.display !== 'none' && style.visibility !== 'hidden' && el.offsetParent !== null;
      });
    }

    function onDocumentEscape(e) {
      if (e.key === 'Escape' && drawer.hasAttribute('open')) {
        e.preventDefault();
        closeDrawer();
      }
    }

    function onDrawerKeydown(e) {
      if (e.key !== 'Tab') return;
      const focusable = getFocusableElements();
      if (focusable.length === 0) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    function openDrawer() {
      if (drawer.hasAttribute('open')) return;
      lastFocusBeforeOpen = document.activeElement;
      drawer.setAttribute('open', '');
      drawer.setAttribute('aria-hidden', 'false');
      openButtons.forEach(function (b) {
        b.setAttribute('aria-expanded', 'true');
      });
      document.documentElement.classList.add(DRAWER_OPEN_CLASS);
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', onDocumentEscape);
      drawer.addEventListener('keydown', onDrawerKeydown);
      window.setTimeout(function () {
        const focusable = getFocusableElements();
        if (focusable.length) focusable[0].focus();
      }, 0);
    }

    function closeDrawer() {
      if (!drawer.hasAttribute('open')) return;
      document.removeEventListener('keydown', onDocumentEscape);
      drawer.removeEventListener('keydown', onDrawerKeydown);
      drawer.removeAttribute('open');
      drawer.setAttribute('aria-hidden', 'true');
      openButtons.forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
      document.documentElement.classList.remove(DRAWER_OPEN_CLASS);
      document.body.style.overflow = '';
      if (lastFocusBeforeOpen && typeof lastFocusBeforeOpen.focus === 'function') {
        window.setTimeout(function () {
          lastFocusBeforeOpen.focus();
        }, 0);
      }
      lastFocusBeforeOpen = null;
    }

    openButtons.forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', openDrawer);
    });

    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', closeDrawer);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initThemeToggle();
      initDrawer();
    });
  } else {
    initThemeToggle();
    initDrawer();
  }
})();
